<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="1308px"
    @close="close"
    id="Dialog"
  >
    <template #title>
      <div class="top">
        <img src="../../assets/placard.png" alt />
        <div class="title">历史问题</div>
      </div>
    </template>
    <el-row :gutter="20">
      <el-col :span="15">
        <el-table
          :data="data"
          height="600"
          style="width: 100%"
          class="table"
          @row-click="handleCurrentChange"
          highlight-current-row
          ref="table"
          header-row-class-name="customTable"
        >
          <el-table-column
            align="center"
            prop="code"
            label="事件编号"
            width="120"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="uptime"
            label="时间"
            width="110"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="p0"
            label="类型"
            width="90"
          ></el-table-column>
          <el-table-column align="center" label="文字描述" width="180">
            <template slot-scope="scopes">
              <span class="desc ellipsis">{{ scopes.row.p2 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="img"
            label="图片"
            min-width="160"
          >
            <template slot-scope="scopes">
              <div
                v-for="(item, index) in scopes.row.p3"
                :key="index"
                class="img"
              >
                <!-- <img :src="item" alt /> -->
                <el-image
                  style="width: 32px; height: 18px"
                  :src="item + '?x-oss-process=image/resize,w_100'"
                  :preview-src-list="scopes.row.p3"
                ></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="uname"
            label="上传人"
            width="110"
          ></el-table-column>
          <el-table-column align="center" label="状态" width="100">
            <template slot-scope="scopes">
              <span class="blue">{{ scopes.row.status }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="9">
        <div class="detail">
          <div class="title">问题详情</div>
          <div class="main">
            <div class="item" v-for="(item, index) in detailList" :key="index">
              <span class="key">{{ item.name + ":" }}</span>
              <span
                :class="['value', item.name === '问题描述' ? 'ellipsis ' : '']"
                >{{ item.value }}</span
              >
            </div>
            <div class="item">
              <span class="key">图片：</span>
              <div class="pics">
                <div class="pic" v-for="(item, index) in imgList" :key="index">
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="item"
                    :preview-src-list="imgList"
                  ></el-image>
                </div>
              </div>
            </div>
          </div>
          <div class="footer">
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in timeLineList"
                :key="index"
              >
                <template>
                  <div>
                    <div class="top">
                      <div class="time">{{ item.updatedtime }}</div>
                      <div class="status blue">{{ item.status }}</div>
                    </div>
                    <div class="bottom">{{ item.dept }}-{{ item.uname }}</div>
                  </div>
                </template>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-col>
    </el-row>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="page"
      :limit.sync="size"
      @pagination="pagination"
    />
  </el-dialog>
</template>

<script>
import { getServerData } from "../../utils/fetchData";
import { APIMAP } from "../../constants/apiConstants";
import Pagination from "../common/Pagination";

export default {
  name: "History",
  props: {
    eid: {
      type: String,
      required: true,
    },
    construction: {
      type: String,
      require: true,
    },
  },
  components: {
    Pagination,
  },
  data() {
    return {
      dialogVisible: true,
      data: [],
      detailList: [],
      imgList: [],
      activities: [
        {
          time: "2018-04-13",
          name: "xxx部门-王大锤",
          status: "上传",
        },
        {
          time: "2018-04-13",
          name: "xxx部门-王大锤",
          status: "上传",
        },
      ],
      timeLineList: [],

      status: "",
      page: 1,
      size: 10,
      total: 0,
    };
  },
  created() {
    this.getHistoryData();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async getHistoryData() {
      try {
        const params = {};
        params.page = this.page;
        params.size = this.size;
        params.eid = this.eid;
        params.status = 99;
        // params.construction = this.construction;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.EVENT, params);
        console.log("返回数据", res);
        res.rows.forEach((item) => {
          item.p3 = item.p3 !== null ? item.p3.split("|") : item.p3;
          switch (item.status) {
            case "-2":
              item.status = "被驳回";
              break;
            case "-1":
              item.status = "已删除";
              break;
            case "0":
              item.status = "待审核";
              break;
            case "1":
              item.status = "待签批";
              break;
            case "2":
              item.status = "待处理";
              break;
            case "3":
              item.status = "待处罚";
              break;
            case "4":
              item.status = "待扣分";
              break;
            case "5":
              item.status = "待整改";
              break;
            case "6":
              item.status = "申诉待处理";
              break;
            case "7":
              item.status = "待复查";
              break;
            case "8":
              item.status = "待归档";
              break;
            case "9":
              item.status = "已完结";
              break;
            default:
              break;
          }
        });
        this.data = res.rows;
        this.total = res.total;
        // 获取第一个的详情数据
        this.getDetailData(res.rows[0].gid);
        this.$refs.table.setCurrentRow(this.data[0]);
      } catch (error) {
        console.log(error);
      }
    },
    handleCurrentChange(val) {
      // console.log(val);
      // 先清空，因为后面会push进去
      this.detailList = [];
      this.imgList = [];
      this.getDetailData(val.gid);
    },
    async getDetailData(gid) {
      try {
        const params = {};
        params.gid = gid;
        params.eid = this.eid;
        console.log("请求参数", params);
        const res = await getServerData(APIMAP.EVENT + `/${gid}`, params);
        console.log("返回数据", res);
        res.slave.forEach((item) => {
          switch (item.status) {
            case -2:
              item.status = "被驳回";
              break;
            case -1:
              item.status = "已删除";
              break;
            case 0:
              item.status = "待审核";
              break;
            case 1:
              item.status = "待签批";
              break;
            case 2:
              item.status = "待处理";
              break;
            case 3:
              item.status = "待处罚";
              break;
            case 4:
              item.status = "待扣分";
              break;
            case 5:
              item.status = "待整改";
              break;
            case 6:
              item.status = "申诉待处理";
              break;
            case 7:
              item.status = "待复查";
              break;
            case 8:
              item.status = "待归档";
              break;
            case 9:
              item.status = "已完结";
              break;
            default:
              break;
          }
        });
        this.timeLineList = res.slave;
        const { uname, uptime, code, p4, p0, p2, p3 } = res.master;
        this.imgList = p3 !== null ? p3.split("|") : p3;
        let { status } = res.master;
        switch (status) {
          case -2:
            status = "被驳回";
            break;
          case -1:
            status = "已删除";
            break;
          case 0:
            status = "待审核";
            break;
          case 1:
            status = "待签批";
            break;
          case 2:
            status = "待处理";
            break;
          case 3:
            status = "待处罚";
            break;
          case 4:
            status = "待扣分";
            break;
          case 5:
            status = "待整改";
            break;
          case 6:
            status = "申诉待处理";
            break;
          case 7:
            status = "待复查";
            break;
          case 8:
            status = "待归档";
            break;
          case 9:
            status = "已完结";
            break;
          default:
            break;
        }
        this.detailList.push(
          {
            name: "上传人",
            value: uname,
          },
          {
            name: "上传时间",
            value: uptime,
          },
          {
            name: "事件编号",
            value: code,
          },
          {
            name: "当前状态",
            value: status,
          },
          {
            name: "下级流转部门",
            value: p4,
          },
          {
            name: "问题类型",
            value: p0,
          },
          {
            name: "问题描述",
            value: p2,
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    pagination() {
      this.getHistoryData();
    },
    decide(status) {
      switch (status) {
        case "-2":
          this.status = "被驳回";
          break;
        case "-1":
          this.status = "已删除";
          break;
        case "0":
          this.status = "待审核";
          break;
        case "1":
          this.status = "待签批";
          break;
        case "2":
          this.status = "待处理";
          break;
        case "3":
          this.status = "待处罚";
          break;
        case "4":
          this.status = "待扣分";
          break;
        case "5":
          this.status = "待整改";
          break;
        case "6":
          this.status = "申诉待处理";
          break;
        case "7":
          this.status = "待复查";
          break;
        case "8":
          this.status = "待归档";
          break;
        case "9":
          this.status = "已完结";
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang='less' scoped>
.top {
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #2c3a50;
  }
}
.table {
  .desc {
    display: inline-block;
    width: 100%;
    height: 100%;
    font-size: 15px;
    text-align: center;
    color: #353e56;
    letter-spacing: 2px;
  }
  .cell {
    display: flex;
  }
  .img {
    width: 32px;
    height: 28px;
    display: inline-block;
    margin-right: 6px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.detail {
  width: 413px;
  height: 600px;
  opacity: 0.66;
  border: 1px solid #e2e5ec;
  border-radius: 5px;
  padding: 0 27px;
  overflow-y: scroll;
  .title {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 500;
    color: #394259;
    border-bottom: 1px solid #e2e5ec;
  }
  .main {
    .item {
      height: 42px;
      .key {
        display: inline-block;
        width: 105px;
        height: 16px;
        margin-right: 10px;
        font-size: 15px;
        color: #707b86;
      }
      .value {
        font-size: 15px;
        color: #3b445a;
      }
    }
    .item:first-child {
      margin-top: 30px;
    }
    .item:last-child {
      height: auto;
    }
    .pics {
      margin-top: 20px;
      .pic {
        display: inline-block;
        width: 120px;
        height: 72px;
        margin-right: 16px;
        margin-bottom: 16px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .footer {
    min-height: 186px;
    border-top: 1px solid #e2e5ec;
    padding-top: 23px;
    .top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;
      .time {
        font-size: 15px;
        color: #3b445a;
      }
      .status {
        font-size: 13px;
      }
    }
    .bottom {
      font-size: 14px;
      color: #99a9ba;
    }
  }
}

.orange {
  color: #ff817e;
}
.blue {
  color: #009157;
}
.green {
  color: #0ac386;
}
.ellipsis {
  display: inline-block;
  width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
